import { WARNING_COLOR } from '../config/Color'

export const createUischemaStyle = ({
  uischema,
  showRequire,
  validateWarning,
}) => {
  let { valueTextAlign, isBorderWarning, isFieldWarning } = uischema
  let style = { textAlign: valueTextAlign || 'left' }
  let borderColor =
    isBorderWarning || showRequire ? { borderColor: 'red' } : {}

  if (showRequire) {
    style = {
      ...style,
      ...borderColor,
    }
  }
  if (validateWarning) {
    let { labelColor = WARNING_COLOR } = validateWarning
    let textColor = isFieldWarning ? {} : { color: labelColor }
    style = {
      ...style,
      ...borderColor,
      ...textColor,
    }
  }
  return style
}

export const createTextWarningStyle = ({ validateWarning }) => {
  let style = {}
  if (validateWarning) {
    let { labelColor = WARNING_COLOR } = validateWarning
    style = {
      color: labelColor,
    }
  }
  return style
}
